import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import React, { memo } from 'react'
import styles from '../CreateCensusTemplate.module.scss'
import ColumnCard, { type ColumnCardProps } from './ColumnCard'

type SortableColumnCardProps = Omit<ColumnCardProps, 'dragHandleProps'>

function SortableColumnCard(props: SortableColumnCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.rule.id })

  const style: React.CSSProperties = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.92 : undefined,
    zIndex: isDragging ? 3 : undefined,
    position: 'relative',
  }

  const dragHandleProps: React.HTMLAttributes<HTMLButtonElement> = {
    ...attributes,
    ...listeners,
    style: {
      cursor: isDragging ? 'grabbing' : 'grab',
    },
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles.columnsGridItem}
      data-rule-id={props.rule.id}
    >
      <ColumnCard {...props} dragHandleProps={dragHandleProps} />
    </div>
  )
}

export default memo(SortableColumnCard)
